import { paths } from "src/paths";

/** 로그인 후 기본 진입 화면과 상단 대시보드 메뉴가 공유하는 메타데이터다. */
export const dashboardEntry = {
  title: "대시보드",
  path: paths.dashboard.home,
};
